import { render, staticRenderFns } from "./BsButtonToggle.vue?vue&type=template&id=35d77d8a&scoped=true&"
import script from "./BsButtonToggle.vue?vue&type=script&lang=js&"
export * from "./BsButtonToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d77d8a",
  null
  
)

export default component.exports